import {FilterType, LocationAttr, StageState, UpdateState} from "enums";

export default {
    translation: {
        // Keys are grouped by area, sorted in abc order.
        breadcrumbs: {
            ariaLabel: 'breadcrumb',
        },
        button: {
            cancel: 'Cancel',
            delete: 'Delete',
            deleting: 'Deleting...',
            save: 'Save',
            saving: 'Saving...',
        },
        errors: {
            generic: 'We\'re sorry, an error has occurred: ',
            validation: {
                fallback: 'Validation error: {{errorType}}',
                required: 'This field is required',
            }
        },
        filterType: {
            [FilterType.DevicesPerLocation]: 'Devices per Location',
            [FilterType.Locations]: 'Locations',
            [FilterType.Percentage]: 'Percentage',
            [FilterType.Serials]: 'Serial Numbers',
            [FilterType.ThingIDs]: 'Thing IDs',
            [FilterType.LastSeen]: 'Last Seen Date',
            [FilterType.LocationData]: 'Location Attribute',
            [FilterType.MenuVersion]: 'Menu Version',
            [FilterType.FirmwareVersion]: 'Firmware Version',
        },
        home: {
            stageNeedsConfirm: 'Needs confirmation before starting',
            title: 'Updates',
        },
        loader: {
            loading: 'Loading...',
        },
        locationAttr: {
            [LocationAttr.DistributionCenter]: 'Distribution Center',
            [LocationAttr.LocationStatus]: 'Location Status',
            [LocationAttr.LocationTypeCode]: 'Location Type',
            [LocationAttr.MarketName]: 'Market',
        },
        login: {
            manageAccount: 'Manage Okta Account',
            signInButton: 'Sign In',
        },
        navbar: {
            settings: 'Account',
            signedInMessage: 'Signed in as:',
            signOut: 'Sign out',
            userName: 'Welcome {{name}}',
        },
        shared: {
            appName: 'SmartEquip Updater',
        },
        stageState: {
            [StageState.Scheduled]: 'Scheduled',
            [StageState.Running]: 'Running',
            [StageState.Canceled]: 'Canceled',
            [StageState.Error]: 'Error',
            [StageState.Done]: 'Completed',
        },
        stageStateDescription: {
            [StageState.Scheduled]: 'This stage is scheduled to be deployed',
            [StageState.Running]: 'This stage is being deployed',
            [StageState.Canceled]: 'The update was canceled',
            [StageState.Error]: 'A fatal error occurred',
            [StageState.Done]: 'This stage successfully completed',
        },
        updateState: {
            [UpdateState.Draft]: 'Draft',
            [UpdateState.AwaitApproval]: 'Needs approval',
            [UpdateState.Scheduled]: 'Scheduled',
            [UpdateState.Running]: 'Deploying update',
            [UpdateState.Canceled]: 'Canceled',
            [UpdateState.Error]: 'Error',
            [UpdateState.Done]: 'Completed',
        },
    }
}
